import { Persona, makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { FC } from 'react';
import { formatDisplayName, generateInitials } from '../../Utils/personaUtils';
import './MenuPersona.scss';

interface MenuPersonaProps {
    name?: string;
    photo?: string;
}

const useStyles = makeStyles({
    root: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
    minWidth: 0,
    maxWidth: '340px',
    width: 'auto',
    },
    personaButton: {
        minWidth: 0,
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        overflow: 'visible',
    },
    personaButtonCentered: {
        minWidth: 0,
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'visible',
    },
});

// implements the user persona display without logout functionality (logout moved to Settings page)
const MenuPersona: FC<MenuPersonaProps> = (props) => {
    const { name, photo } = props;
    const classes = useStyles();
    
    const displayName = formatDisplayName(name);
    const initials = generateInitials(name);

    return (
        <div className={classes.root}>
            <div className={`${name ? classes.personaButton : classes.personaButtonCentered} ${!name ? 'menu-persona-centered' : ''}`}>
                <Persona
                    name={displayName}
                    size="extra-small"
                    textAlignment="center"
                    avatar={{
                        image: photo ? { src: photo } : undefined,
                        initials: {
                            children: initials,
                            style: {}
                        },
                        style: {
                            backgroundColor: 'transparent'
                        }
                    }}
                    primaryText={{
                        style: {
                            fontSize: tokens.fontSizeBase300,
                            fontWeight: tokens.fontWeightMedium,
                            color: tokens.colorNeutralForeground1,
                            overflow: 'visible',
                            textOverflow: 'unset',
                            whiteSpace: 'normal',
                            maxWidth: '100%',
                            display: name ? 'block' : 'none',
                        }
                    }}
                />
            </div>
        </div>
    );
};

export default MenuPersona;

